import {useSelector} from "react-redux";
import {useEffect, useMemo, useState} from "react";
import {hasAdminPermission} from "./admin-access";

export function PermissionGate({ permission, children, fallback = null, scopeId, scopeRolePermissions }) {
    const {workspaceMembershipData} = useSelector((state) => state.app);
    const {user} = useSelector((state) => state.auth);
    const userRoles = useMemo(
        () => workspaceMembershipData?.user_roles || [],
        [workspaceMembershipData?.user_roles]
    );
    const [permissions, setPermissions] = useState([]);

    useEffect(() => {
        let userRole = userRoles.find(ur=>ur.role==="admin"||ur.role==="owner");
        setPermissions(userRole?.permissions || []);
    }, [userRoles]);

    useEffect(() => {
        if (scopeId){
            let userWorkspaceRole = userRoles.find(ur=>ur.role==="admin"||ur.role==="owner");
            let userScopeRole = userRoles.find(ur=>ur.scope_id===scopeId);
            setPermissions([
                ...(userWorkspaceRole?.permissions ?? []),
                ...(scopeRolePermissions?.[userScopeRole?.role] ?? [])
            ]);
        }
    }, [scopeId, scopeRolePermissions, userRoles]);

    if (!permission){
        return children;
    }

    if (hasAdminPermission(user, permission)) {
        return children;
    }

    if (permissions.includes("*") || permissions.includes(permission)) {
        return children;
    }

    return fallback;

}

export default PermissionGate;

